import React from 'react'
import styles from './OverviewV2.module.scss'
import OverviewV2Logo from './OverviewV2Logo'
import { OverviewV2MetaList } from './OverviewV2MetaList'
import { OverviewV2MetaItem } from './types'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'uikit/tooltips/default/tooltip'

interface OverviewCompanyHeaderProps {
  name?: string
  image?: string
  descriptor?: string
  metaItems: OverviewV2MetaItem[]
  status?: OverviewV2MetaItem
  about?: string
}

const OverviewCompanyHeader = ({
  name,
  image,
  descriptor,
  metaItems,
  status,
  about,
}: OverviewCompanyHeaderProps) => {
  return (
    <div className={styles.companyRow}>
      <OverviewV2Logo name={name} image={image} />
      <div className={styles.companyContent}>
        <div className={styles.companyTitle}>
          <>
            <span className={styles.companyName}>{name || 'N/A'}</span>
            <span>|</span>
            <span className={styles.companyDescriptor}>
              {descriptor}
              {about ? (
                <Tooltip title={about} placement='bottomLeft' classNames={{ root: styles.aboutTooltip }}>
                  <InfoCircleOutlined />
                </Tooltip>
              ) : null}
            </span>
            {status ? status.value : null}
          </>
        </div>
        <OverviewV2MetaList items={metaItems} />
      </div>
    </div>
  )
}
export default OverviewCompanyHeader
